<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img18.jpg"/></p>
<p class="chap"><a id="ch8"></a>BRITAIN AND VIRGINIA, 1607</p>
<p class="noindent"><span class="big">S</span>ince the Middle Ages, England’s wealth came from wool. Each year, tons of raw wool were harvested from sheep on English hillsides and shipped to the European continent, where the material was fashioned into cloth. By 1600, however, the wool trade had been disrupted by religious and economic fighting in Europe. There was a glut of wool in France and Holland, which before had bought England’s raw wool. English King James I, who derived much of his income from export taxes, began to look elsewhere for funds to make up for the shortfall in tax on English wool. His openness to colonizing North America was fueled by fears of Spanish encroachment on English claims in the region and the age-old hope that gold and silver, similar to that found by the Spanish in Mexico and Peru, might be secured by the English colonists because there never seemed to be enough money in circulation to pay for all the goods the English wanted to buy.</p>
<p class="indent">There never seemed to be enough money to pay for all the goods Englishmen wanted to buy. With a growing population, jails filled to overcapacity, and increasing unemployment, the government began to look for places to put people. And religious dissenters feeling oppressed by the Church of England wanted a place to practice their faith freely. These and other reasons created the desire to plant colonies in North America. <span class="color">(11-070, 11-071, 11-072)</span></p>
<p class="image"><img alt="image" src="images/img19.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter008.vue?57c6f581